import { t } from 'ttag';

import { Button } from '@ui/Button';

// styles
import s from './SuccessfulComplain.sss';

// types
type SuccessfulComplainProps = {
  onClose: () => void;
};

export const SuccessfulComplain: React.FC<SuccessfulComplainProps> = ({
  onClose,
}) => (
  <div className={s.root}>
    <h4 className={s.title}>{t`Дякуємо, що розповіли про ситуацію!`}</h4>

    <p className={s.paragraph}>
      {t`Звернення прийнято в роботу. Нам потрібен час, щоб розібратися. На це може піти до 3-х днів.
      Будь ласка, не відправляйте декілька повідомлень про порушення.
      Ми розглядаємо всі звернення по порядку і без винятків. Без повторів справляємося набагато швидше.`}
    </p>

    <Button
      type="submit"
      className={s.button}
      onClick={onClose}
    >
      {t`Добре`}
    </Button>
  </div>
);

export default SuccessfulComplain;
